export default __webpack_public_path__ + "static/lenta-498503c221b839be44f027f87623e573.webp";